<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../../../../../../_shared/_logic/rich-tooltips"
  import type { CustomerRow } from "../../_shared/_logic/customers-table-contract"

  let { row }: { row: CustomerRow } = $props()
</script>

<span class="object-cell">
  {#each row.objectEntries ?? [] as object (`${row.id}-${object.id}`)}
    <StatusTag
      variant="neutral"
      size="sm"
      label={object.tag.label}
      subLabel={object.tag.subLabel}
      color={object.tag.color}
      icon={object.tag.icon}
      tooltipContent={object.tooltip}
      tooltipHtml={object.tooltipHtml ?? false}
      tooltipClassName={object.tooltipHtml ? RICH_TOOLTIP_CLASS : ""}
      disableTitle={true}
    />
  {/each}
</span>

<style lang="less">
  .object-cell {
    display: inline-flex;
    min-width: 0;
    max-width: 100%;
    align-items: flex-start;
    flex-direction: column;
    gap: 0.32rem;
    white-space: normal;
  }
</style>
